import {AuditDamageValueBody, ImageMeta, TConditionFormValue} from '../../../types/ConditionTypes';
import {isJsonString} from '../../../utils/isJsonString';

type ParsedValue = (TConditionFormValue & ImageMeta & AuditDamageValueBody[]) | null;

export const getParsedValue = (value?: string | null): ParsedValue =>
  value && isJsonString(value) ? (JSON.parse(value) as ParsedValue) : null;
